import { render, staticRenderFns } from "./deliveryAddress.vue?vue&type=template&id=98949a76&scoped=true&"
import script from "./deliveryAddress.vue?vue&type=script&lang=js&"
export * from "./deliveryAddress.vue?vue&type=script&lang=js&"
import style0 from "./deliveryAddress.vue?vue&type=style&index=0&id=98949a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98949a76",
  null
  
)

export default component.exports